
import React, { memo } from 'react';
import { EmailTemplateEditor } from '@/components/admin/settings/EmailTemplateEditor';

interface TemplateEditorContentProps {
  templateId: string;
  onBack: () => void;
  onSave: () => void;
}

export const TemplateEditorContent = memo(function TemplateEditorContent({ 
  templateId, 
  onBack, 
  onSave
}: TemplateEditorContentProps) {
  return (
    <div className="w-full">
      <EmailTemplateEditor 
        templateId={templateId} 
        onBack={onBack}
        onSave={onSave}
      />
    </div>
  );
});
